<script>
  import { redirect } from "../pager";
  import Alert from "../components/Alert.svelte";
  import { fade } from "svelte/transition";
  import Load from "../components/Load.svelte";
  import SkContent from "./Rule/SkContent.svelte";
  import KpContent from "./Rule/KpContent.svelte";
  import Modal from "../components/Modal.svelte";
  import DatePicker from "svelte-touch-datepicker";

  import axios from "axios";
  import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  $: if (settings) {
    if (settings.loggedin == true) {
      window.location.href = "./";
    }
  } else {
    settings = {
      url: "https://api.dekatan.com",
      loggedin: false,
    };
  }
  let alertMessage = "Proses berlangsung";
  let alertType = "2";
  let alert = [];
  let shake = "shake";
  localStorage["area"] = "";
  let user = "";
  let pass = "";
  let pass_verify = "";
  let areaawal = "";
  let areaawalinput = "";
  if (localStorage["area"]) {
    areaawal = localStorage["area"];
  }
  let area = areaawal;

  let require;

  $: require = {
    area: area,
    email: "",
    pass: "",
    pass_verify: "",
    nik: "",
    nokk: "",
    nama: "",
    tl: "",
    tgl: "",
    rt: "",
    rw: "",
    kp: "",
    jk: "",
    agm: "",
    pen: "",
    krj: "",
    stat: "",
    hdk: "",
    ayah: "",
    ibu: "",
    setuju: "",
  };
  let number;
  $: number = {
    nik: require.nik,
    nokk: require.nokk,
    rt: require.rt,
    rw: require.rw,
  };

  let require_check;

  $: require_check = {
    area: "",
    nik: "",
    nokk: "",
    nama: "",
    tl: "",
    tgl: "",
    rt: "",
    rw: "",
    kp: "",
    jk: "",
    agm: "",
    pen: "",
    krj: "",
    stat: "",
    hdk: "",
    ayah: "",
    ibu: "",
  };
  let number_check;
  $: number = {
    nik: require.nik,
    nokk: require.nokk,
    rt: require.rt,
    rw: require.rw,
  };

  let email;
  $: email = {
    email: require.email,
  };

  let requireOnExist;

  $: requireOnExist = {
    area: area,
    email: require.email,
    pass: require.pass,
    pass_verify: require.pass_verify,
    nik: require.nik,
    setuju: require.setuju,
  };

  let numberOnExist;
  $: numberOnExist = {
    nik: require.nik,
  };

  //#FORM Data Payload

  let errorForm = [];
  function validator() {
    errorForm = [];
    for (var k in require) {
      if (document.getElementById(k + "-labelwarning")) {
        document.getElementById(k + "-labelwarning").style = "";
      }
      if (document.getElementById(k + "-warning")) {
        document.getElementById(k + "-warning").style.display = "none";
        document.getElementById(k + "-warning").innerHTML = "";
      }
      if (
        require[k] !== undefined &&
        require[k] !== null &&
        require[k] !== "" &&
        require[k] !== false
      ) {
      } else {
        errorForm = [...errorForm, { field: k, message: "Mohon diisi" }];
        if (document.getElementById(k + "-warning")) {
          document.getElementById(k + "-warning").style.display =
            "inline-block";
          document.getElementById(k + "-warning").innerHTML = "Mohon diisi";
        }
        if (document.getElementById(k + "-labelwarning")) {
          document.getElementById(k + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }
    for (var n in number) {
      if (document.getElementById(n + "-warning")) {
        document.getElementById(n + "-warning").style.display = "none";
        document.getElementById(n + "-labelwarning").style = "";
        document.getElementById(n + "-warning").innerHTML = "";
      }
      if (/^\+?(0|[1-9]\d*)$/.test(number[n])) {
      } else {
        errorForm = [
          ...errorForm,
          { field: n, message: "Pastikan Hanya Angka" },
        ];
        if (document.getElementById(n + "-warning")) {
          document.getElementById(n + "-warning").style.display =
            "inline-block";
          document.getElementById(n + "-warning").innerHTML =
            "Pastikan Hanya Angka";
        }
        if (document.getElementById(n + "-labelwarning")) {
          document.getElementById(n + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }
    for (var e in email) {
      if (document.getElementById(e + "-warning")) {
        document.getElementById(e + "-warning").style.display = "none";
        document.getElementById(e + "-labelwarning").style = "";
        document.getElementById(e + "-warning").innerHTML = "";
      }
      if (
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          email[e]
        )
      ) {
      } else {
        errorForm = [
          ...errorForm,
          { field: e, message: "Pastikan Email sudah tepat" },
        ];
        if (document.getElementById(e + "-warning")) {
          document.getElementById(e + "-warning").style.display =
            "inline-block";
          document.getElementById(e + "-warning").innerHTML =
            "Pastikan Email sudah tepat";
        }
        if (document.getElementById(e + "-labelwarning")) {
          document.getElementById(e + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    if (errorForm.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  function validator_check() {
    errorForm = [];
    for (var k in require_check) {
      if (document.getElementById(k + "-labelwarning")) {
        document.getElementById(k + "-labelwarning").style = "";
      }
      if (document.getElementById(k + "-warning")) {
        document.getElementById(k + "-warning").style.display = "none";
        document.getElementById(k + "-warning").innerHTML = "";
      }
      if (
        require[k] !== undefined &&
        require[k] !== null &&
        require[k] !== "" &&
        require[k] !== false
      ) {
      } else {
        errorForm = [...errorForm, { field: k, message: "Mohon diisi" }];
        if (document.getElementById(k + "-warning")) {
          document.getElementById(k + "-warning").style.display =
            "inline-block";
          document.getElementById(k + "-warning").innerHTML = "Mohon diisi";
        }
        if (document.getElementById(k + "-labelwarning")) {
          document.getElementById(k + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    for (var n in number_check) {
      document.getElementById(n + "-warning").style.display = "none";
      document.getElementById(n + "-labelwarning").style = "";
      document.getElementById(n + "-warning").innerHTML = "";
      if (/^\+?(0|[1-9]\d*)$/.test(number[n])) {
      } else {
        errorForm = [
          ...errorForm,
          { field: n, message: "Pastikan Hanya Angka" },
        ];
        if (document.getElementById(n + "-warning")) {
          document.getElementById(n + "-warning").style.display =
            "inline-block";
          document.getElementById(n + "-warning").innerHTML =
            "Pastikan Hanya Angka";
        }
        if (document.getElementById(n + "-labelwarning")) {
          document.getElementById(n + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    if (errorForm.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  function validatorOnExist() {
    errorForm = [];
    for (var k in requireOnExist) {
      if (document.getElementById(k + "-labelwarning")) {
        document.getElementById(k + "-labelwarning").style = "";
      }
      if (document.getElementById(k + "-warning")) {
        document.getElementById(k + "-warning").style.display = "none";
        document.getElementById(k + "-warning").innerHTML = "";
      }
      if (
        requireOnExist[k] !== undefined &&
        requireOnExist[k] !== null &&
        requireOnExist[k] !== "" &&
        requireOnExist[k] !== false
      ) {
      } else {
        errorForm = [...errorForm, { field: k, message: "Mohon diisi" }];
        if (document.getElementById(k + "-warning")) {
          document.getElementById(k + "-warning").style.display =
            "inline-block";
          document.getElementById(k + "-warning").innerHTML = "Mohon diisi";
        }
        if (document.getElementById(k + "-labelwarning")) {
          document.getElementById(k + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }
    for (var n in numberOnExist) {
      if (document.getElementById(n + "-warning")) {
        document.getElementById(n + "-warning").style.display = "none";
        document.getElementById(n + "-labelwarning").style = "";
        document.getElementById(n + "-warning").innerHTML = "";
      }
      if (/^\+?(0|[1-9]\d*)$/.test(numberOnExist[n])) {
      } else {
        errorForm = [
          ...errorForm,
          { field: n, message: "Pastikan Hanya Angka" },
        ];
        if (document.getElementById(n + "-warning")) {
          document.getElementById(n + "-warning").style.display =
            "inline-block";
          document.getElementById(n + "-warning").innerHTML =
            "Pastikan Hanya Angka";
        }
        if (document.getElementById(n + "-labelwarning")) {
          document.getElementById(n + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }
    for (var e in email) {
      if (document.getElementById(e + "-warning")) {
        document.getElementById(e + "-warning").style.display = "none";
        document.getElementById(e + "-labelwarning").style = "";
        document.getElementById(e + "-warning").innerHTML = "";
      }
      if (
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          email[e]
        )
      ) {
      } else {
        errorForm = [
          ...errorForm,
          { field: e, message: "Pastikan Email sudah tepat" },
        ];
        if (document.getElementById(e + "-warning")) {
          document.getElementById(e + "-warning").style.display =
            "inline-block";
          document.getElementById(e + "-warning").innerHTML =
            "Pastikan Email sudah tepat";
        }
        if (document.getElementById(e + "-labelwarning")) {
          document.getElementById(e + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    if (errorForm.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  function validatorNik() {
    errorForm = [];
    for (var n in numberOnExist) {
      if (document.getElementById(n + "-warning")) {
        document.getElementById(n + "-warning").style.display = "none";
        document.getElementById(n + "-labelwarning").style = "";
        document.getElementById(n + "-warning").innerHTML = "";
      }
      if (/^\+?(0|[1-9]\d*)$/.test(numberOnExist[n])) {
      } else {
        errorForm = [
          ...errorForm,
          { field: n, message: "Pastikan Hanya Angka" },
        ];
        if (document.getElementById(n + "-warning")) {
          document.getElementById(n + "-warning").style.display =
            "inline-block";
          document.getElementById(n + "-warning").innerHTML =
            "Pastikan Hanya Angka";
        }
        if (document.getElementById(n + "-labelwarning")) {
          document.getElementById(n + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }
    if (errorForm.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  $: if (localStorage["area"]) {
    localStorage["area"] = area;
  } else {
    localStorage["area"] = area;
  }

  if (localStorage["inputarea"]) {
    areaawalinput = localStorage["inputarea"];
  }
  let inputarea = areaawalinput;
  $: if (localStorage["inputarea"]) {
    localStorage["inputarea"] = inputarea;
  } else {
    localStorage["inputarea"] = inputarea;
  }

  let result = false;

  let loading = false;
  let bio = false;
  let btntonext = false;
  let statusNIK;

  async function niktotgl(niktotgl) {
    let noktotglthn;
    let noktotgltgl;
    if (/^\+?(0|[1-9]\d*)$/.test(niktotgl)) {
      if (niktotgl.length >= 12) {
        niktotgl = niktotgl.match(/.{1,2}/g);
        if (niktotgl[5] > 30) {
          noktotglthn = "19" + niktotgl[5];
        } else {
          noktotglthn = "20" + niktotgl[5];
        }
        if (niktotgl[3] > 31) {
          noktotgltgl = niktotgl[3] - 40;
          if (noktotgltgl <= 9) {
            noktotgltgl = "0" + noktotgltgl;
          }
          require.jk = 2;
          setTimeout(() => {
            document.getElementById("t_kelamin").value = 2;
          }, 2000);
        } else {
          noktotgltgl = niktotgl[3];
          require.jk = 1;
          setTimeout(() => {
            document.getElementById("t_kelamin").value = 1;
          }, 2000);
        }
        if (noktotgltgl <= 9) {
          noktotgltgl = noktotgltgl;
        }
        let niktobln;
        if (niktotgl[4].match(/.{1,1}/g)[0] != 0) {
          niktobln = niktotgl[4];
        } else {
          niktobln = niktotgl[4].match(/.{1,1}/g)[1];
        }
        date.setFullYear(noktotglthn, niktobln - 1, noktotgltgl);
        datecallback();

        validatorNik();
      }
    } else {
      validatorNik();
    }
  }

  async function handleCheckNIK(event) {
    bio = false;

    if (/^\+?(0|[1-9]\d*)$/.test(require.nik)) {
      if (require.nik.length == 16) {
        loading = true;

        axios
          .post(settings.url + "/auth/nik", {
            area: require.area,
            nik: require.nik,
          })
          .then(function (response) {
            if (response.status == "201") {
              btntonext = true;
              statusNIK = 201;
              nextStep();
            }

            if (response.status == "200") {
              bio = true;
              statusNIK = 200;
              niktotgl(require.nik);
            }

            loading = false;
          })
          .catch(function (error) {
            btntonext = false;
            bio = false;
            statusNIK = 400;
            loading = false;
          });
      } else {
        statusNIK = 0;
      }

      validatorNik();
    } else {
      validatorNik();
    }
  }

  async function handleCheck(event) {
    loading = true;
    let valid = validator_check();
    if (valid) {
      loading = false;
      nextStep();
    } else {
      loading = false;
      shake = "shake";
      setTimeout(() => {
        shake = "";
      }, 1000);
    }
  }
  let success;
  $: success = false;
  async function handleSubmit(event) {
    loading = true;
    let valid;
    let payload;
    if (statusNIK == "201") {
      valid = validatorOnExist();
      payload = {
        area: require.area,
        email: require.email,
        pass: require.pass,
        pass_verify: require.pass_verify,
        nik: require.nik,
      };
    } else {
      valid = validator();
      payload = {
        area: require.area,
        email: require.email,
        pass: require.pass,
        pass_verify: require.pass_verify,
        nik: require.nik,
        nokk: require.nokk,
        nama: require.nama,
        tl: require.tl,
        tgl: require.tgl,
        jk: require.jk,
        agm: require.agm,
        rt: require.rt,
        rw: require.rw,
        kp: require.kp,
        pen: require.pen,
        krj: require.krj,
        stat: require.stat,
        hdk: require.hdk,
        ayah: require.ayah,
        ibu: require.ibu,
      };
    }
    if (valid) {
      shake = "";
      axios
        .post(settings.url + "/auth/daftar", payload)
        .then(function (response) {
          alert = [
            ...alert,
            {
              title: "Oke Berhasil...",
              message: response.data.message,
              color: "green",
            },
          ];
          success = true;
          loading = false;
        })
        .catch(function (error) {
          success = false;
          loading = false;

          shake = "shake";
          alert = [
            ...alert,
            {
              title: "Oops...",
              message: error.response.data.message,
              color: "orange",
            },
          ];
        });
    } else {
      success = false;
      loading = false;
      shake = "shake";
    }
  }

  let step = 1;
  function nextStep() {
    loading = true;
    shake = "";

    if (document.getElementsByClassName("tablist").length >= step - 1) {
      document.getElementById("stepID" + step).className = "";
      document.getElementById("stepcontID" + step).style.display = "none";
      step = step + 1;
      document.getElementById("stepID" + step).className = "active";
      document.getElementById("stepcontID" + step).style.display = "block";
      loading = false;
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  function backStep() {
    loading = true;
    if (document.getElementsByClassName("tablist").length <= step - 1) {
      document.getElementById("stepID" + step).className = "";
      document.getElementById("stepcontID" + step).style.display = "none";
      step = step - 1;
      document.getElementById("stepID" + step).className = "active";
      document.getElementById("stepcontID" + step).style.display = "block";
      loading = false;
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  let items = [];
  function cariDesa() {
    loading = true;
    if (inputarea.length > 2) {
      axios
        .get(settings.url + "/publik/desa/" + inputarea)
        .then(function (response) {
          items = response.data.list;
          loading = false;
        })
        .catch(function (error) {
          loading = false;

          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: "Anda belum terhubung dengan baik",
              color: "orange",
            },
          ];
        });
    } else {
      loading = false;
      alert = [
        ...alert,
        {
          title: "Dekatan",
          message: "Ketik setidaknya 3 huruf untuk mencari desa",
          color: "orange",
        },
      ];
    }
  }

  let date = new Date();
  $: _date = date.toLocaleDateString("id-ID");
  function datecallback(event) {
    require.tgl = _date;
  }
</script>

<svelte:head>
  <title>Mendaftar Ke Dekatan</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}

<main transition:fade class="container px-2 pt-0 mx-auto mb-2 lg:pt-0 md:pt-16">
  {#if loading}
    <Load />
  {/if}
  <div class={shake}>
    <div class="w-full mx-auto mt-24 lg:mt-5 md:w-2/4 lg:w-2/5">
      <div class="flex justify-center font-bold">
        <img
          on:click={() => redirect("/")}
          src="./assets/logo/logo.svg"
          width="274"
          height="64"
          alt="logo"
          class="h-16 cursor-pointer"
        />
      </div>
      <h2 class="mb-4 text-center text-gray-700 text-1xl">
        <b>Daftarkan</b> diri kamu sekarang
      </h2>

      {#if success == true}
        <div class="flex flex-wrap items-center w-full mx-auto my-5 lg:my-0 ">
          <div class="w-full mx-auto mb-2">
            <div class="block p-5 py-10 bg-white rounded-lg shadow-md group">
              <p class="text-center">
                <b class="block mb-5 text-xl">Selamat akun kamu sudah siap!</b
                >Sekarang kamu bisa masuk ke aplikasi dengan menggunakan
                <b>email &amp; kata sandi</b>
                yang baru saja kamu buat<br />
                <a
                  href="/login"
                  class="block px-5 py-2 my-5 text-white bg-green-600 rounded"
                  >Login</a
                >
              </p>
            </div>
          </div>
        </div>
      {:else}
        <div class="flex flex-wrap items-center w-full mx-auto my-5 lg:my-0 ">
          <div class="w-full mx-auto mb-2">
            <div class="block px-4 py-3 bg-white rounded-lg shadow-md group">
              <ul class="mt-5 mb-10 list-unstyled multi-steps tablist">
                <li role="presentation" id="stepID1" class="active">
                  <span class="text-sm">Cari Desa</span>
                </li>
                <li role="presentation" id="stepID2">
                  <span class="text-sm">Lengkapi</span>
                </li>
                <li role="presentation" id="stepID3">
                  <span class="text-sm">Keamanan</span>
                </li>
              </ul>
              <div id="stepcontID1" class="stepcontID">
                <div class="px-2 pb-2">
                  <div class="w-full mb-2">
                    <p
                      class="p-1 my-5 text-sm italic text-center text-green-600 bg-white border border-green-600 rounded-md"
                    >
                      Kitiklah Nama Desa tempat kamu berdomisili saat ini !
                    </p>
                    <div class="flex items-center">
                      <input
                        name="area"
                        autocomplete="off"
                        bind:value={inputarea}
                        type="text"
                        placeholder="Ketik Nama Desa Disini"
                        class="w-full px-3 py-2 text-2xl text-center text-gray-700 border rounded "
                      />
                    </div>
                  </div>
                  {#if loading}
                    <button
                      type="button"
                      class="w-full px-5 py-2 mt-2 text-gray-100 bg-green-600 rounded-lg opacity-25 text-1xl focus:bg-gray-500 focus:outline-none"
                      disabled="disabled"
                    >
                      Mencari...
                    </button>
                  {:else}
                    <button
                      type="button"
                      class="w-full px-5 py-2 mt-2 text-gray-100 bg-green-600 rounded-lg text-1xl focus:bg-gray-500 focus:outline-none"
                      on:click={cariDesa}
                    >
                      CARI
                    </button>
                  {/if}
                </div>
                {#if items}
                  <div class="pb-10">
                    {#each items as d, i}
                      <a
                        transition:fade
                        href
                        on:click|preventDefault
                        on:click={nextStep}
                        on:click={() => (area = d.kode)}
                        class="block w-full px-4 py-3 my-3 transition-all duration-300 transform scale-100 bg-gray-100 rounded-md shadow cursor-pointer hover:bg-white hover:scale-110 hover:shadow-outline"
                      >
                        <div
                          class="flex items-center justify-between text-left"
                        >
                          <span class="text-base text-gray-800">
                            <b>{d.desa}</b>
                            -
                            {d.kode}
                            <br />
                            {d.kec}
                            {d.kab}
                          </span>
                          <span
                            class="px-3 py-1 font-bold text-gray-100 bg-gray-400 rounded-lg"
                          >
                            &gt;
                          </span>
                        </div>
                      </a>
                    {/each}
                  </div>
                {:else}
                  <div class="pb-10">
                    <div transition:fade class="w-full lg:w-auto">
                      <div
                        class="w-full p-2 mx-auto mb-2 text-xs bg-orange-300 border-4 border-t border-b border-r border-orange-600 border-solid rounded shadow-lg lg:w-auto color-white"
                      >
                        <h2 class="text-sm font-bold">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            class="inline-block w-5 h-5"
                          >
                            <path
                              d="M4 8a6 6 0 0 1 4.03-5.67 2 2 0 1 1 3.95 0A6 6 0 0
                              1 16 8v6l3 2v1H1v-1l3-2V8zm8 10a2 2 0 1 1-4 0h4z"
                            />
                          </svg>
                          Oops..
                        </h2>
                        <p>
                          Tidak menemukan data, silahkan coba kata kunci lain...
                        </p>
                      </div>
                    </div>
                  </div>
                {/if}

                <div class="mt-5 separator">atau</div>
                <p class="flex items-center justify-between my-2">
                  <a
                    href="/login"
                    class="block w-full px-5 py-2 text-xs text-center text-blue-700 focus:outline-none"
                    ><span class="text-gray-700">Sudah Punya Akun ?</span>
                    <br />Login</a
                  >
                  <a
                    href="/forget"
                    class="block w-full px-5 py-2 text-xs text-center text-orange-700 focus:outline-none"
                    ><span class="text-gray-700">Lupa Password ?</span>
                    <br />Pulihkan</a
                  >
                </p>
              </div>

              <div id="stepcontID2" class="hidden stepcontID">
                <form autocomplete="off" on:submit|preventDefault>
                  <div id="collapseTpenKK" aria-expanded="true" class="px-2">
                    <section class="mt-5">
                      <label
                        for="nik"
                        class="relative block text-sm font-light"
                      >
                        <input
                          name="nik"
                          id="nik"
                          placeholder="NIK"
                          type="text"
                          class="w-full form-input"
                          pattern="[0-9]*"
                          inputmode="numeric"
                          minlength="16"
                          maxlength="16"
                          bind:value={require.nik}
                          on:keyup={handleCheckNIK}
                        />
                        <span
                          class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                          id="nik-labelwarning"
                          >NIK/Nomor KTP
                        </span>
                        <span
                          class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                          id="nik-warning"
                        />
                      </label>
                    </section>

                    {#if statusNIK < 16 || statusNIK == undefined}
                      <p
                        class="p-1 my-5 text-sm italic text-center text-green-600 bg-white border border-green-600 rounded-md"
                      >
                        Pastikan NIK terdiri dari 16 digit dan sesuai KTP anda !
                      </p>
                    {/if}
                    {#if btntonext}
                      {#if bio == false}
                        <button
                          type="button"
                          class="w-full px-5 py-2 mt-5 text-gray-100 bg-green-600 rounded-lg text-1xl focus:bg-gray-500 focus:outline-none"
                          on:click={nextStep}
                        >
                          LANJUT
                        </button>
                      {/if}
                    {/if}
                    {#if bio}
                      <section class="mt-5">
                        <label
                          for="nokk"
                          class="relative block text-sm font-light"
                        >
                          <input
                            name="nokk"
                            id="nokk"
                            placeholder="Nomor KK"
                            type="text"
                            class="w-full form-input"
                            pattern="[0-9]*"
                            inputmode="numeric"
                            minlength="16"
                            maxlength="16"
                            bind:value={require.nokk}
                          />
                          <span
                            class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                            id="nokk-labelwarning"
                          >
                            Nomor KK
                          </span>
                          <span
                            class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                            id="nokk-warning"
                          />
                        </label>
                      </section>

                      <section class="mt-5">
                        <label
                          for="nama"
                          class="relative block text-sm font-light"
                        >
                          <input
                            name="nama"
                            id="nama"
                            type="text"
                            placeholder="Nama Lengkap"
                            class="w-full form-input"
                            bind:value={require.nama}
                          />
                          <span
                            class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                            id="nama-labelwarning"
                            >Nama Lengkap
                          </span>
                          <span
                            class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                            id="nama-warning"
                          />
                        </label>
                      </section>

                      <section class="mt-5">
                        <label
                          for="tl"
                          class="relative block text-sm font-light"
                        >
                          <input
                            name="tl"
                            id="tl"
                            type="text"
                            placeholder="Tempat Lahir"
                            class="w-full form-input"
                            bind:value={require.tl}
                          />
                          <span
                            class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                            id="tl-labelwarning"
                            >Tempat Lahir
                          </span>
                          <span
                            class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                            id="tl-warning"
                          />
                        </label>
                      </section>

                      <section class="mt-5">
                        <label
                          for="tgl"
                          class="relative block text-sm font-light"
                        >
                          <DatePicker
                            bind:date
                            on:dateChange={datecallback}
                            classes="form-input"
                          />
                          <span
                            class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                            id="tgl-labelwarning"
                            >Tanggal Lahir
                          </span><br />
                          <span
                            class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                            id="tgl-warning"
                          />
                        </label>
                      </section>

                      <section class="mt-5">
                        <label
                          for="rt"
                          class="relative block text-sm font-light"
                        >
                          <input
                            name="rt"
                            id="rt"
                            type="number"
                            min="1"
                            max="100"
                            placeholder="RT"
                            class="w-full form-input"
                            style="width: 150px;"
                            bind:value={require.rt}
                          />
                          <span
                            class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                            id="rt-labelwarning"
                            >RT
                          </span><br />
                          <span
                            class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                            id="rt-warning"
                          />
                        </label>
                      </section>

                      <section class="mt-5">
                        <label
                          for="rw"
                          class="relative block text-sm font-light"
                        >
                          <input
                            name="rw"
                            id="rw"
                            type="number"
                            min="1"
                            max="100"
                            placeholder="RW"
                            class="w-full form-input"
                            style="width: 150px;"
                            bind:value={require.rw}
                          />
                          <span
                            class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                            id="rw-labelwarning"
                            >RW
                          </span><br />
                          <span
                            class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                            id="rw-warning"
                          />
                        </label>
                      </section>

                      <section class="mt-5">
                        <label
                          for="kp"
                          class="relative block text-sm font-light"
                        >
                          <input
                            name="kp"
                            id="kp"
                            type="text"
                            placeholder="Kampung ex (KP. Beringin)"
                            class="w-full form-input"
                            bind:value={require.kp}
                          />
                          <span
                            class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                            id="kp-labelwarning"
                            >Kampung
                          </span><br />
                          <span
                            class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                            id="kp-warning"
                          />
                        </label>
                      </section>

                      <section class="mt-5">
                        <label
                          for="jk"
                          class="relative block text-sm font-light"
                        >
                          <select
                            bind:value={require.jk}
                            name="kelamin"
                            id="t_kelamin"
                            class="form-select"
                            ><option value=""> Jenis Kelamin </option>
                            <option value="1">Laki-Laki</option>
                            <option value="2">Perempuan</option></select
                          >
                          <span
                            class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                            id="jk-labelwarning"
                            >Jenis Kelamin
                          </span><br />
                          <span
                            class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                            id="jk-warning"
                          />
                        </label>
                      </section>

                      <section class="mt-5">
                        <label
                          for="agm"
                          class="relative block text-sm font-light"
                        >
                          <select
                            bind:value={require.agm}
                            name="agm"
                            id="agm"
                            class="form-select"
                            ><option value="">Agama</option>
                            <option value="1">Islam</option>
                            <option value="2">Kristen</option>
                            <option value="3">Katholik</option>
                            <option value="4">Hindu</option>
                            <option value="5">Budha</option>
                            <option value="6">Lainnya</option></select
                          >
                          <span
                            class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                            id="agm-labelwarning"
                            >Agama
                          </span><br />
                          <span
                            class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                            id="agm-warning"
                          />
                        </label>
                      </section>

                      <section class="mt-5">
                        <label
                          for="pen"
                          class="relative block text-sm font-light"
                        >
                          <select
                            bind:value={require.pen}
                            name="pen"
                            id="pen"
                            class="form-select"
                            ><option value=""> Pendidikan </option>
                            <option value="1">Tidak/Belum Sekolah</option>
                            <option value="2">Belum Tamat SD/Sederajat</option>
                            <option value="3">Tamat SD/Sederajat</option>
                            <option value="4">SLTP/Sederajat</option>
                            <option value="5">SLTA/Sederajat</option>
                            <option value="6">Diploma I/II</option>
                            <option value="7">
                              Akademi/Diploma III /Sarjana Muda
                            </option>
                            <option value="8">Diploma IV/Strata I</option>
                            <option value="9">Strata II</option>
                            <option value="10">Strata III</option></select
                          >
                          <span
                            class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                            id="pen-labelwarning"
                            >Pendidikan
                          </span><br />
                          <span
                            class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                            id="pen-warning"
                          />
                        </label>
                      </section>

                      <section class="mt-5">
                        <label
                          for="krj"
                          class="relative block text-sm font-light"
                        >
                          <select
                            bind:value={require.krj}
                            name="krj"
                            id="krj"
                            class="w-full form-select"
                            ><option value=""> Pekerjaan </option>
                            <option value="1">Belum/Tidak Bekerja</option>
                            <option value="2">Mengurus Rumah Tangga</option>
                            <option value="3">Pelajar/Mahasiswa</option>
                            <option value="4">Pensiunan</option>
                            <option value="5">
                              Pegawai Negeri Sipil (PNS)
                            </option>
                            <option value="6">
                              Tentara Nasional Indonesia (TNI)
                            </option>
                            <option value="7">Kepolisian (POLRI)</option>
                            <option value="8">Perdagangan</option>
                            <option value="9">Petani/Pekebun</option>
                            <option value="10">Peternak</option>
                            <option value="11">Nelayan/Perikanan</option>
                            <option value="12">Industri</option>
                            <option value="13">Konstruksi</option>
                            <option value="14">Transportasi</option>
                            <option value="15">Karyawan Swasta</option>
                            <option value="16">Karyawan BUMN</option>
                            <option value="17">Karyawan BUMD</option>
                            <option value="18">Karyawan Honorer</option>
                            <option value="19">Buruh Harian Lepas</option>
                            <option value="20">Buruh Tani/Perkebunan</option>
                            <option value="21">Buruh Nelayan/Perikanan</option>
                            <option value="22">Buruh Peternakan</option>
                            <option value="23">Pembantu Rumah Tangga</option>
                            <option value="24">Tukang Cukur</option>
                            <option value="25">Tukang Listrik</option>
                            <option value="26">Tukang Batu</option>
                            <option value="27">Tukang Kayu</option>
                            <option value="28">Tukang Sol Sepatu</option>
                            <option value="29">Tukang Las/Pandai Besi</option>
                            <option value="30">Tukang Jahit</option>
                            <option value="31">Tukang Gigi</option>
                            <option value="32">Penata Rias</option>
                            <option value="33">Penata Busana</option>
                            <option value="34">Penata Rambut</option>
                            <option value="35">Mekanik</option>
                            <option value="36">Seniman</option>
                            <option value="37">Tabib</option>
                            <option value="38">Paraji</option>
                            <option value="39">Perancang Busana</option>
                            <option value="40">Penterjemah</option>
                            <option value="41">Imam Masjid</option>
                            <option value="42">Pendeta</option>
                            <option value="43">Pastor</option>
                            <option value="44">Wartawan</option>
                            <option value="45">Ustadz/Mubaligh</option>
                            <option value="46">Juru Masak</option>
                            <option value="47">Promotor Acara</option>
                            <option value="48">Anggota DPR-RI</option>
                            <option value="49">Anggota DPD</option>
                            <option value="50">Anggota BPK</option>
                            <option value="51">Presiden</option>
                            <option value="52">Wakil Presiden</option>
                            <option value="53">
                              Anggota Mahkamah Konstitusi
                            </option>
                            <option value="54">
                              Anggota Kabinet/Kementrian
                            </option>
                            <option value="55">Duta Besar</option>
                            <option value="56">Gubernur</option>
                            <option value="57">Wakil Gubernur</option>
                            <option value="58">Bupati</option>
                            <option value="59">Wakil Bupati</option>
                            <option value="60">Walikota</option>
                            <option value="61">Wakil Walikota</option>
                            <option value="62">Anggota DPRD Prop</option>
                            <option value="63">
                              Anggota DPRD Kab Kota PROPESI LAIN SELAIN PEGAWAI
                            </option>
                            <option value="64">Dosen</option>
                            <option value="65">Guru</option>
                            <option value="66">Pilot</option>
                            <option value="67">Pengacara</option>
                            <option value="68">Notaris</option>
                            <option value="69">Arsitek</option>
                            <option value="70">Akuntan</option>
                            <option value="71">Konsultan</option>
                            <option value="72">Dokter</option>
                            <option value="73">Bidan</option>
                            <option value="74">Perawat</option>
                            <option value="75">Apoteker</option>
                            <option value="76">Psikiater/Psikolog</option>
                            <option value="77">Penyiar Televisi</option>
                            <option value="78">Penyiar Radio</option>
                            <option value="79">Pelaut</option>
                            <option value="80">Peneliti</option>
                            <option value="81">Sopir</option>
                            <option value="82">Pialang</option>
                            <option value="83">Paranormal</option>
                            <option value="84">Pedagang</option>
                            <option value="85">Perangkat Desa</option>
                            <option value="86">Kepala Desa</option>
                            <option value="87">Biarawati</option>
                            <option value="88">Wiraswasta</option>
                            <option value="89">Lainnya</option></select
                          >
                          <span
                            class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                            id="krj-labelwarning"
                            >Pekerjaan
                          </span><br />
                          <span
                            class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                            id="krj-warning"
                          />
                        </label>
                      </section>

                      <section class="mt-5">
                        <label
                          for="stat"
                          class="relative block text-sm font-light"
                        >
                          <select
                            bind:value={require.stat}
                            name="stat"
                            id="stat"
                            class="form-select"
                            ><option value=""> Status Perkawinan </option>
                            <option value="1">Belum Kawin</option>
                            <option value="2">Kawin</option>
                            <option value="3">Cerai Hidup</option>
                            <option value="4">Cerai Mati</option></select
                          >
                          <span
                            class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                            id="stat-labelwarning"
                            >Status Pernikahan
                          </span><br />
                          <span
                            class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                            id="stat-warning"
                          />
                        </label>
                      </section>

                      <section class="mt-5">
                        <label
                          for="hdk"
                          class="relative block text-sm font-light"
                        >
                          <select
                            bind:value={require.hdk}
                            name="hdk"
                            id="hdk"
                            class="form-select"
                            ><option value=""> Hubungan Dalam Keluarga </option>
                            <option value="1">Kepala Keluarga</option>
                            <option value="2">Suami</option>
                            <option value="3">Isteri</option>
                            <option value="4">Anak</option>
                            <option value="5">Menantu</option>
                            <option value="6">Cucu</option>
                            <option value="7">Orang Tua</option>
                            <option value="8">Mertua</option>
                            <option value="9">Famili Lain</option>
                            <option value="10">Pembantu</option>
                            <option value="11">Lainnya</option></select
                          >
                          <span
                            class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                            id="hdk-labelwarning"
                            >Status Dalam Keluarga
                          </span><br />
                          <span
                            class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                            id="hdk-warning"
                          />
                        </label>
                      </section>

                      <section class="mt-5">
                        <label
                          for="ayah"
                          class="relative block text-sm font-light"
                        >
                          <input
                            name="ayah"
                            id="ayah"
                            type="text"
                            placeholder="Nama Ayah"
                            class="w-full form-input"
                            bind:value={require.ayah}
                          />
                          <span
                            class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                            id="ayah-labelwarning"
                            >Nama Ayah
                          </span>
                          <span
                            class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                            id="ayah-warning"
                          />
                        </label>
                      </section>

                      <section class="mt-5">
                        <label
                          for="ibu"
                          class="relative block text-sm font-light"
                        >
                          <input
                            name="ibu"
                            id="ibu"
                            type="text"
                            placeholder="Nama Ibu"
                            class="w-full form-input"
                            bind:value={require.ibu}
                          />
                          <span
                            class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                            id="ibu-labelwarning"
                            >Nama Ibu
                          </span>
                          <span
                            class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                            id="ibu-warning"
                          />
                        </label>
                      </section>

                      <button
                        type="button"
                        class="w-full px-5 py-2 mt-10 text-gray-100 bg-green-600 rounded-lg text-1xl focus:bg-gray-500 focus:outline-none"
                        on:click={handleCheck}
                      >
                        LANJUT
                      </button>
                    {:else if statusNIK == 400}
                      <p
                        class="p-1 my-5 text-sm italic text-center text-red-600 bg-white border border-red-600 rounded-md shake"
                      >
                        Oops.. NIK sudah terdaftar dengan akun lain !
                      </p>
                    {/if}
                    <a
                      href="/daftar"
                      on:click|preventDefault={backStep}
                      class="inline-block px-2 py-1 my-2 text-sm text-green-600 border rounded focus:outline-none"
                      >&lt; Kembali ...</a
                    >
                  </div>
                </form>
              </div>

              <div id="stepcontID3" class="hidden stepcontID">
                <form
                  class="px-2"
                  autocomplete="off"
                  on:submit|preventDefault={handleSubmit}
                >
                  <section class="mt-5">
                    <label
                      for="email"
                      class="relative block text-sm font-light"
                    >
                      <input
                        class="w-full form-input"
                        name="email"
                        id="email"
                        autocomplete="off"
                        type="text"
                        placeholder="Email"
                        bind:value={require.email}
                      />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="email-labelwarning"
                        >Email
                      </span>
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="email-warning"
                      />
                    </label>
                  </section>

                  <section class="mt-5">
                    <label for="pass" class="relative block text-sm font-light">
                      <input
                        class="w-full form-input"
                        name="pass"
                        id="pass"
                        autocomplete="off"
                        type="password"
                        placeholder="Kata Sandi"
                        bind:value={require.pass}
                      />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="pass-labelwarning"
                        >Kata Sandi
                      </span>
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="pass-warning"
                      />
                    </label>
                  </section>

                  <section class="mt-5">
                    <label
                      for="pass_verify"
                      class="relative block text-sm font-light"
                    >
                      <input
                        class="w-full form-input"
                        name="pass_verify"
                        id="pass_verify"
                        autocomplete="off"
                        type="password"
                        placeholder="Ulangi Kata Sandi"
                        bind:value={require.pass_verify}
                      />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="pass_verify-labelwarning"
                        >Ulangi Kata Sandi
                      </span>
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="pass_verify-warning"
                      />
                    </label>
                  </section>
                  <section class="mt-5">
                    <p class="flex text-xs text-gray-500">
                      <label
                        for="setuju"
                        class="relative flex text-sm font-light"
                      >
                        <input
                          name="setuju"
                          id="setuju"
                          type="checkbox"
                          class="my-1 mr-5 text-3xl form-checkbox hover:shadow-outline"
                          bind:checked={require.setuju}
                        />
                        <div>
                          Saya telah membaca dan menyetujui
                          <Modal backdropClose size="lg:w-2/5 w-full">
                            <span slot="trigger" let:open>
                              <span on:click={open} class="text-green-500"
                                >Syarat & Ketentuan
                              </span>
                            </span>
                            <div slot="header" class="text-center">
                              <h1 class="text-lg">Syarat & Ketentuan</h1>
                            </div>
                            <div
                              slot="content"
                              class="h-auto"
                              style="max-height:100%"
                            >
                              <SkContent />
                            </div>
                          </Modal>

                          serta
                          <Modal backdropClose size="lg:w-2/5 w-full">
                            <span slot="trigger" let:open>
                              <span on:click={open} class="text-green-500"
                                >Kebijakan Privasi
                              </span>
                            </span>
                            <div slot="header" class="text-center">
                              <h1 class="text-lg">Kebijakan Privasi</h1>
                            </div>
                            <div
                              slot="content"
                              class="h-auto"
                              style="max-height:100%"
                            >
                              <KpContent />
                            </div>
                          </Modal>
                          Dekatan
                        </div>
                        <span
                          class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                          id="setuju-warning"
                        />
                      </label>
                    </p>
                  </section>

                  <div class="flex items-center justify-between my-5">
                    <button
                      type="button"
                      class="w-auto px-5 py-2 font-light text-gray-500 text-1xl focus:outline-none"
                      on:click={backStep}
                    >
                      Kembali ...
                    </button>

                    {#if loading}
                      <button
                        type="submit"
                        class="w-auto px-16 py-2 mt-5 text-gray-100 bg-green-600 rounded-lg opacity-25 text-1xl focus:bg-gray-500 focus:outline-none"
                        disabled="disabled"
                      >
                        MEMPROSES...
                      </button>
                    {:else}
                      <button
                        type="submit"
                        class="w-auto px-16 py-2 mt-5 text-gray-100 bg-green-600 rounded-lg text-1xl focus:bg-gray-500 focus:outline-none"
                        on:click={handleSubmit}
                      >
                        DAFTAR
                      </button>
                    {/if}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
</main>
<div class="flex justify-center max-w-screen-xl px-5 py-1 mx-auto items-bottom">
  <div
    class="w-full mt-4 text-sm font-light text-center text-gray-700 sm:py-2 sm:mt-0"
  >
    <div>
      <span class="ml-1 text-gray-700"
        >© 2021 Dekatan — PT. Rakit Solutions Indonesia</span
      >
    </div>
  </div>
</div>
